import React from 'react';
import QuestionCard from '../forms/QuestionCard';
import { useFormContext } from '../../context/FormContext';

const PersonalInfoQuestions = ({ 
  questionNumber, 
  categories, 
  totalQuestions 
}) => {
  const { formData, handleInputChange } = useFormContext();
  
  switch(questionNumber) {
    case 1:
      return (
        <QuestionCard
          categoryIcon={categories[0].icon}
          categoryName={categories[0].name}
          questionNumber={1}
          totalQuestions={totalQuestions}
          title="你的姓名（或昵称）"
          value={formData.fullName}
          onChange={(value) => handleInputChange('fullName', value)}
          inputType="textarea"
        />
      );
    case 2:
      return (
        <QuestionCard
          categoryIcon={categories[0].icon}
          categoryName={categories[0].name}
          questionNumber={2}
          totalQuestions={totalQuestions}
          title="你的微信号"
          value={formData.wechat}
          onChange={(value) => handleInputChange('wechat', value)}
          inputType="textarea"
        />
      );
    case 3:
        return (
            <QuestionCard
                categoryIcon={categories[0].icon}
                categoryName={categories[0].name}
                questionNumber={3}
                totalQuestions={totalQuestions}
                title="你的邮箱"
                value={formData.email}
                onChange={(value) => handleInputChange('email', value)}
                inputType="textarea"
            />
        );
    case 4:
      return (
        <QuestionCard
          categoryIcon={categories[0].icon}
          categoryName={categories[0].name}
          questionNumber={4}
          totalQuestions={totalQuestions}
          title="你的学校"
          value={formData.school}
          onChange={(value) => handleInputChange('school', value)}
          inputType="textarea"
        />
      );
    case 5:
      return (
        <QuestionCard
          categoryIcon={categories[0].icon}
          categoryName={categories[0].name}
          questionNumber={5}
          totalQuestions={totalQuestions}
          title="你的年级"
          value={formData.grade}
          onChange={(value) => handleInputChange('grade', value)}
          inputType="textarea"
        />
      );
    case 6:
      return (
        <QuestionCard
          categoryIcon={categories[0].icon}
          categoryName={categories[0].name}
          questionNumber={6}
          totalQuestions={totalQuestions}
          title="你的专业（备注是否打算转专业）"
          value={formData.major}
          onChange={(value) => handleInputChange('major', value)}
          inputType="textarea"
        />
      );
    default:
      return null;
  }
};

export default PersonalInfoQuestions;